import * as React from "react";
function findPathParent(obj, arr) {
  if (!obj)
    return;
  arr.push(obj.type);
  const children = obj.props?.children;
  if (obj.type === "path" && !children) {
    return arr.pop();
  } else if (typeof children === "object") {
    if (Array.isArray(children)) {
      for (let i = 0; i < children.length; i++) {
        const result = findPathParent(children[i], arr);
        if (result) {
          break;
        }
      }
    } else {
      findPathParent(children, arr);
    }
  } else {
    arr.pop();
  }
}
function addNewStyle(newStyle) {
  let styleElement = document.getElementById("styles_js");
  if (!styleElement) {
    styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.id = "styles_js";
    document.getElementsByTagName("head")[0].appendChild(styleElement);
  }
  styleElement.appendChild(document.createTextNode(newStyle));
}
function changePathStyle(props, arr, id) {
  if (!props)
    return;
  const str = arr.join(" ");
  const root = arr[0];
  const others = arr.slice(1);
  if (props.color) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props.color + "}");
  }
  if (props["data-hovercolor"]) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovercolor"] + "}");
  }
  if (props["data-activecolor"]) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activecolor"] + "}");
  }
  if (Array.isArray(props["data-twotonecolor"])) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-twotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-twotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-hovertwotonecolor"])) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovertwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-hovertwotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-activetwotonecolor"])) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activetwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-activetwotonecolor"][1] + "}");
  }
  if (props.width) {
    addNewStyle(root + "#" + id + "{width: " + props.width + "}");
  }
  if (props.height) {
    addNewStyle(root + "#" + id + "{height: " + props.height + "}");
  }
}
const isArrayContainsElement = (arr1, arr2) => {
  for (let i = 0; i < arr2.length; i++) {
    if (arr1.includes(arr2[i])) {
      return true;
    }
  }
  return false;
};
const OPTIONS = ["color", "data-activecolor", "data-hovercolor", "data-twotonecolor", "data-hovertwotonecolor", "data-activetwotonecolor", "width", "height"];
const SvgClose = (props) => {
  const isSetOptions = isArrayContainsElement(Object.keys(props), OPTIONS);
  const svg = /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", id: "close_svg_plugin_81639", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.68626 13.3034C3.60816 13.3815 3.48153 13.3815 3.40342 13.3034L2.69631 12.5963C2.61821 12.5182 2.61821 12.3915 2.69631 12.3134L7.00964 8.00009L2.69627 3.68673C2.61817 3.60863 2.61817 3.48199 2.69627 3.40389L3.40338 2.69678C3.48149 2.61868 3.60812 2.61868 3.68622 2.69678L7.99959 7.01014L12.313 2.69676C12.3911 2.61866 12.5177 2.61866 12.5958 2.69676L13.3029 3.40387C13.381 3.48197 13.381 3.60861 13.3029 3.68671L8.98954 8.00009L13.3029 12.3134C13.381 12.3915 13.381 12.5182 13.3029 12.5963L12.5958 13.3034C12.5177 13.3815 12.391 13.3815 12.3129 13.3034L7.99959 8.99004L3.68626 13.3034Z" }));
  if (isSetOptions) {
    const parents = [];
    findPathParent(svg, parents);
    const id = svg.props.id;
    changePathStyle(props, parents, id);
  }
  return svg;
};
export default SvgClose;
